import { render, staticRenderFns } from "./AddEditInfoPage.vue?vue&type=template&id=3d49738f&scoped=true&"
import script from "./AddEditInfoPage.vue?vue&type=script&lang=ts&"
export * from "./AddEditInfoPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddEditInfoPage.vue?vue&type=style&index=0&id=3d49738f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d49738f",
  null
  
)

export default component.exports